<div class="color-pallet-wrapper">
    <div class="pickers row-centered" *ngIf="color">
        <div
            class="color-picker-container"
            [style.background]="color"
            [matMenuTriggerFor]="menu"
            [style.width]="palletSize"
            [style.height]="palletSize"
            #menuTrigger="matMenuTrigger">
            <div class="edit row-centered">
                <mat-icon class="small-icon">edit</mat-icon>
            </div>
        </div>
        <div class="custom-color-menu" *ngIf="colorMenuOpen === key">
            <button class="close-color-menu" (click)="closeColorPicker()" aria-label="Close color menu">×</button>
        </div>
    </div>
    <mat-menu #menu="matMenu">
        <app-color-picker
            [key]="key"
            [color]="color"
            [displayBrandColors]="this.displayBrandColors"
            (colorChanged)="colorChangedAsync($event)">
        </app-color-picker>
    </mat-menu>
</div>
